var map = {
	"./abb-color.svg": 1716,
	"./afb-color.svg": 1717,
	"./afb.svg": 1718,
	"./alb-color.svg": 1719,
	"./alb.svg": 1720,
	"./amb-color.svg": 1721,
	"./amb.svg": 1722,
	"./bbbaidja-color.svg": 1723,
	"./bbbaidjaxxx-color.svg": 1724,
	"./bdinidjaxxx-color.svg": 1725,
	"./bimb-color.svg": 1726,
	"./bimb.svg": 1727,
	"./bkr-color.svg": 1728,
	"./bkr.svg": 1729,
	"./bmriidja-color.svg": 1730,
	"./bniaidja-color.svg": 1731,
	"./bninidja-color.svg": 1732,
	"./bninidjaxxx-color.svg": 1733,
	"./bpay-color.svg": 1734,
	"./brinidja002-color.svg": 1735,
	"./bsmdidjaxxx-color.svg": 1736,
	"./bsn-color.svg": 1737,
	"./bsn.svg": 1738,
	"./btanidjaxxx-color.svg": 1739,
	"./cenaidja-color.svg": 1740,
	"./cenaidjaxxx-color.svg": 1741,
	"./cimb-color.svg": 1742,
	"./cimb.svg": 1743,
	"./citi-color.svg": 1744,
	"./citi.svg": 1745,
	"./default-bank-icon-color.png": 1746,
	"./default-bank-icon.png": 1747,
	"./gxbank-color.svg": 1748,
	"./hlb-color.svg": 1749,
	"./hlb.svg": 1750,
	"./hsbc-color.svg": 1751,
	"./hsbc.svg": 1752,
	"./ibbkidjaxxx-color.svg": 1753,
	"./kwh-color.svg": 1754,
	"./kwh.svg": 1755,
	"./mbb-color.svg": 1756,
	"./mbb.svg": 1757,
	"./nispidjaxxx-color.svg": 1758,
	"./ocbc-color.svg": 1759,
	"./ocbc.svg": 1760,
	"./pbb-color.svg": 1761,
	"./pbb.svg": 1762,
	"./pinbidja-color.svg": 1763,
	"./rhb-b.svg": 1764,
	"./rhb-color-b.svg": 1765,
	"./rhb-color.svg": 1766,
	"./rhb.svg": 1767,
	"./scb-color.svg": 1768,
	"./scb.svg": 1769,
	"./tng-color.svg": 1770,
	"./uob-color.svg": 1771,
	"./uob.svg": 1772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;